import clsx from 'clsx';

import { InventoryAssetTreeStateType } from '@atom/types/inventory';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

enum AttributeGroupNames {
  ELEMENT_DETAILS = 'Element Details',
}

interface Props {
  elements: InventoryAssetTreeStateType[];
  elementName: string;
}

const ElementDetailsTable = ({ elements, elementName }: Props) => {
  const getElementDetailsTable = (assetTypes = [], usedAssetTypes = []) => {
    let attributeMax = 0;
    elements.forEach(element => {
      element.attributeGroups.forEach(attributeGroup => {
        if (attributeGroup.name === AttributeGroupNames.ELEMENT_DETAILS) {
          const attributeLength = attributeGroup.attributes.length;
          if (attributeLength > attributeMax) {
            attributeMax = attributeLength;
          }
          if (!assetTypes.includes(element.assetType)) {
            assetTypes.push(element.assetType);
          }
        }
      });
    });

    const isUsedAssetType = assetType => {
      if (!usedAssetTypes.includes(assetType)) {
        usedAssetTypes.push(assetType);
        return false;
      }
      return true;
    };

    return assetTypes.map((assetType, index) => (
      <div className={classes.tableWrapper}>
        <table>
          {index === 0 && (
            <thead>
              <tr>
                <th colSpan={attributeMax + 1}>
                  <div className={classes.tableHeader}>
                    {elementName} Element Details
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody>
            {elements.map(element => {
              return element.attributeGroups.map(attributeGroup => {
                if (
                  attributeGroup.name === AttributeGroupNames.ELEMENT_DETAILS &&
                  element.assetType === assetType
                ) {
                  return (
                    <>
                      {!isUsedAssetType(assetType) && (
                        <tr className={classes.tableSubheader}>
                          <th>Element</th>
                          {attributeGroup.attributes.map(key => {
                            const style = clsx(
                              classes.tableHeaderCell,
                              element.attributes[key].name === 'Comment' &&
                                classes.comment,
                            );

                            return (
                              <th className={style}>
                                {element.attributes[key].name}
                              </th>
                            );
                          })}
                        </tr>
                      )}
                      <tr className={classes.tableValue}>
                        <td>{element.name}</td>
                        {attributeGroup.attributes.map(key => (
                          <td>
                            {attributeDisplayUtility.display(
                              element.attributes[key].value,
                              element.attributes[key].dataType,
                              element.attributes[key].unit,
                              !!element.attributes[key].changeId,
                              element.attributes[key].newValue,
                            )}
                          </td>
                        ))}
                      </tr>
                    </>
                  );
                }
                return <></>;
              });
            })}
          </tbody>
        </table>
      </div>
    ));
  };

  return <>{getElementDetailsTable()}</>;
};

export default ElementDetailsTable;
